class AMC_Offercircle {
    constructor(el) {
        this.el = el;
        this.circle = el.find('.circle');
        this.border = el.find('.circle__border');
        this.icons = el.find('.circle__icon');
        this.hastargets = el.find('[data-target]');

        this.init();
    }

    setupCirclePos() {
        let r = this.border.outerWidth() / 2,
            d = 360 / this.icons.length * Math.PI / 180,
            d9 = -90 * Math.PI / 180;

        if (this.border.css('display') === 'none') {
            this.icons.prop('style', '');
            return;
        }

        this.icons.each(function(i) {
            var x = r + r * Math.cos(i * d + d9),
                y = r + r * Math.sin(i * d + d9);

            $(this).css({
                top: y,
                left: x
            });
        });

        // if (this.el.css('display') === 'flex') {
        //     this.el.find('.active').removeClass('active');
        //     this.el.find('.circle-active').removeClass('circle-active');
        // } else {
        //     let target = this.icons.eq(0).data('target');
        //     if (target) {
        //         this.el.find('.active').removeClass('active');
        //         $(target).addClass('active');
        //         $('[data-target="' + target + '"]', this).addClass('active');
        //     }
        // }
    }

    events() {
        let self = this;

        this.hastargets.on('click mouseover', function(e) {
            e.preventDefault();
            let target = $(this).data('target');

            self.el.find('.content-cn .content').addClass('circle-active');
            self.el.find('.active').removeClass('active');
            $(target).addClass('active');
            self.el.find('[data-target="' + target + '"]').addClass('active');
        });

        this.hastargets.on('mouseleave', function(e) {
            if (window.ismobile) return;
            if (window.innerWidth < 990) return;

            let target = $(this).data('target');
            let $target = $(target);

            $target.removeClass('active');
            self.el.find('[data-target="' + target + '"]').removeClass('active');
            self.el.find('.content-cn .content').removeClass('circle-active');
        });
    }

    init() {
        let self = this;

        this.events();
        this.setupCirclePos();

        let debounced = _.debounce(function () {
            self.setupCirclePos();
        }, 150);
        $(window).on('resize orientationchange', debounced);
    }
}